import { UpdateUserPayload, User } from '../../../../types';
import { ConstructPatch } from '../../../types/ConstructPatch';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { USER_BASE_PATH } from '../constants/userBasePath';

export const patchUpdateUser = async (
  constructPatch: ConstructPatch,
  uuid: string,
  data: UpdateUserPayload,
): Promise<NonPaginatedResponse<User> | undefined> =>
  constructPatch<NonPaginatedResponse<User>>(
    `${USER_BASE_PATH}/${uuid}`,
    { data },
    { preventDefaultErrorToast: true },
  );
